var map = {
	"./4140434_logo_volkswagen_vw_icon.svg": 8325,
	"./4140435_logo_tesla_tesla-motors_icon.svg": 2812,
	"./4140436_bmw_logo_icon.svg": 3234,
	"./4140438_logo_mercedes_icon.svg": 933,
	"./4141639_logo_toyota_icon.svg": 9374,
	"./4141660_logo_subaru_icon.svg": 625,
	"./4141777_logo_mini_icon.svg": 220,
	"./4141793_logo_mitsubishi_icon.svg": 6249,
	"./4142330_land_land rover_logo_rover_icon.svg": 6085,
	"./4142910_logo_nissan_icon.svg": 242,
	"./4143278_citroen_logo_icon.svg": 2735,
	"./5707254_fiat_logo_icon.svg": 4444,
	"./ford_logo.svg": 8923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7796;